import React from 'react';

import Divider from '~/components/ui/atoms/Divider';

const DividerCell = () => (
  <div className="row-span-2 px-4 first:hidden">
    <Divider orientation="vertical" variant="middle" className="m-0" />
  </div>
);

export default DividerCell;
